import React from 'react';
import Style from '../shared/Style.js';
import Util from './Util.js';
import { ValueText } from "./DetailText.js";
import AttributeDetailRenderer from "./AttributeDetailRenderer.js";
import Formatters from '../../attribute/formatter/Formatters.js';
import I18nResolvers from '../../attribute/i18nResolver/I18nResolvers.js';
import InlineEditor from "../../attribute/editor/InlineEditor.js";
import IntersectionObserverWrapper from "../../IntersectionObserverWrapper.js";
import { jsx as _jsx } from "react/jsx-runtime";
const USAGE = 'detail';
export default class ArrayPrimitiveAttributeDetailRenderer extends AttributeDetailRenderer {
  getValueComponent(value, valueStyle, obj, cxt, {
    valueVariant
  }) {
    const {
      editable
    } = cxt;
    const context = this.getContext(obj, cxt);
    const {
      value: valueOpts
    } = this.detail;
    if (value.length === 1 && value[0] === '-') {
      return super.getValueComponent(value, valueStyle, obj, cxt, {
        valueVariant: 'detailValue'
      });
    }
    const variantCxt = {
      context: cxt,
      value,
      detailModel: this.detail,
      usage: USAGE
    };
    const paneVariant = Util.getVariant(valueOpts, obj, variantCxt, 'paneVariant');
    const morePopupVariant = Util.getVariant(valueOpts, obj, variantCxt, 'morePopupVariant');
    const moreToggleVariant = Util.getVariant(valueOpts, obj, variantCxt, 'moreToggleVariant');
    const layout = Util.getLayout(valueOpts, obj, variantCxt);
    const cn = /*#__PURE__*/_jsx(IntersectionObserverWrapper, {
      popupVariant: morePopupVariant,
      toggleVariant: moreToggleVariant,
      layout: layout,
      variant: paneVariant,
      adjustable: false,
      value: value,
      children: value?.map((item, index) => {
        return /*#__PURE__*/_jsx(ValueText, {
          "data-targetid": `${item}-${index}`,
          variant: valueVariant,
          style: valueStyle,
          children: item
        }, item);
      })
    });
    return /*#__PURE__*/_jsx(InlineEditor, {
      usage: "detail",
      variant: valueVariant,
      editable: editable,
      attrName: this.name,
      object: obj,
      style: valueStyle,
      context: context,
      children: cn
    }, this.name);
  }
  formatAndI18nResolveValue = value => {
    const formattedValue = Formatters.format(value, this.detail.formatter);
    if (formattedValue == null || formattedValue.length === 0) {
      return null;
    }
    return formattedValue.map(value => I18nResolvers.resolve(value, this.detail)).flat();
  };
}